import axios from '@/utils/axios';
import { ip3 } from '@/utils/constants';
import { DataReqUpdate, ILamThuBay } from '@/services/LamThuBay/index';

export async function getLamThuBay(payload: { page: number; limit: number; cond?: any }) {
  const { page, limit, cond } = payload;
  return axios.get(`${ip3}/lam-thu-bay/pageable`, {
    params: {
      page,
      limit,
      cond,
    },
  });
}
export async function getGiaoVien(payload: {
  donViId: string;
  page: number;
  limit: number;
  cond?: any;
}) {
  const { page, limit, cond, donViId } = payload;
  return axios.get(`${ip3}/ho-so-giao-vien/pageable`, {
    params: {
      donViId,
      page,
      limit,
    },
  });
}

export async function getAllGiaoVien(payload: {
  donViId: string;
  cond?: any;
}) {
  const { cond, donViId } = payload;
  return axios.get(`${ip3}/ho-so-giao-vien/pageable/v2`, {
    params: {
      donViId,
    },
  });
}
export async function getLop(payload: {
  donViId: string;
  page: number;
  limit: number;
  cond?: any;
}) {
  const { page, limit, cond, donViId } = payload;
  return axios.get(`${ip3}/don-vi/pageable/${donViId}/child`, {
    params: {
      page,
      limit,
    },
  });
}

export async function getAllLop(payload: {
  donViId: string;
  cond?: any;
}) {
  const {  cond, donViId } = payload;
  return axios.get(`${ip3}/don-vi/pageable/${donViId}/child/v2`, {
    params: {
      loaiDonVi: "Lop"
    }
  });
}

export async function createLamThuBay(payload: ILamThuBay.DataReq) {
  return axios.post(`${ip3}/lam-thu-bay/hieu-truong`, payload);
}
export async function updateLamThuBay(id: string, data: ILamThuBay.DataReqUpdate) {
  return axios.put(`${ip3}/lam-thu-bay/${id}`, data);
}

export async function confirmLamThuBay(id: string, trangThai: string) {
  return axios.put(`${ip3}/lam-thu-bay/${id}/xac-nhan`, { trangThai: trangThai });
}

export async function checkLamThuBay(payload: { giaoVienId: string; thang: number; nam: number }) {
  const { giaoVienId, thang, nam } = payload;
  return axios.get(`${ip3}/lam-thu-bay/all`, {
    params: {
      cond:{
        giaoVienId: giaoVienId,
        thang: thang,
        nam: nam,
      }
    },
  });
}
